// ----------------------------------------------------------------------

const account = {
  displayName: 'Youssef M.salah',
  email: 'devyoussefsalah@gmail.com',
  photoURL: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__340.png',
};

export default account;
